import { MdShowChart } from 'react-icons/md';

import { ISidebarItem } from '../interfaces/ISidebarItem';

export const sidebar: ISidebarItem[] = [
  {
    key: 'portfolio',
    label: 'Portfolio',
    icon: 'wallet-3-line',
  },
  {
    key: 'wallet',
    label: 'Carteira',
    icon: 'wallet-3-line',
    externalHref: 'https://wallet.cryptocontrol.pro/dashboard',
    // Gate temporário: em teste em produção, visível somente para admins
    adminOnly: true,
  },
  {
    key: 'box',
    label: 'Caixinha',
    customIcon: MdShowChart,
    externalHref: 'https://wallet.cryptocontrol.pro/dashboard/earn',
    // Gate temporário: em teste em produção, visível somente para admins
    adminOnly: true,
  },
  {
    key: 'exchange',
    label: 'Trocar',
    icon: 'arrow-left-right-fill',
    externalHref: 'https://wallet.cryptocontrol.pro/dashboard/swap',
    // Gate temporário: em teste em produção, visível somente para admins
    adminOnly: true,
  },
  {
    key: 'radar',
    label: 'Radar',
    icon: 'radar-line',
  },
  {
    key: 'stock-dashboard',
    label: 'Ações',
    icon: 'line-chart-line',
  },
  {
    // StockRadar (porte do POC): painel de ações americanas. Platinum+, por ora só admin vê o item.
    key: 'stockradar',
    label: 'Stockradar',
    icon: 'crosshair-2-line',
    adminOnly: true,
  },
  {
    key: 'bubbles',
    label: 'Bubbles',
    icon: 'bubble-chart-line',
  },
  {
    key: 'social',
    label: 'Social',
    icon: 'user-community-line',
    adminOnly: true,
    isVisible: false,
  },
  {
    key: 'deepchart',
    label: 'DeepChart',
    icon: 'robot-2-line',
  },
  {
    // Acessada pela página de Configurações (somente admin, por ora). Oculta na sidebar, mas
    // mantida aqui para que a rota /integracoes seja reconhecida como privada (auth provider).
    key: 'integracoes',
    label: 'Integrações',
    icon: 'plug-line',
    isVisible: false,
  },
  {
    key: 'monitor',
    label: 'Monitor',
    icon: 'bar-chart-line',
    children: [
      {
        key: 'moneyflow',
        label: 'Money Flow',
        adminOnly: true,
        isVisible: false,
      },
      {
        key: 'technical-analysis',
        label: 'Análise Técnica',
      },
      {
        key: 'topo-hunter',
        label: 'Topo Hunter',
      },
      {
        key: 'news',
        label: 'Noticias',
        isVisible: false,
      },
    ],
  },
  {
    isVisible: false,
    key: 'training',
    label: 'Treinamentos',
    icon: 'video-line',
  },
  {
    key: 'config',
    label: 'Configurações',
    icon: 'settings-5-line',
    isVisible: false,
  },
  {
    key: 'subscription',
    label: 'Assinaturas',
    icon: 'vip-crown-line',
    isVisible: false,
  },
];
